import { Router } from '@reach/router'
import React from 'react'
import { ROOT_PATH } from './common/config'
import { Home, SMHome, ContactUs, AboutUs, OurDealer, News, NewsDetail, AppNewsDetail, MotorcycleFinancing, ProductDisclosure, PersonalLoan, MotorVehicle, MobileApp, RepaymentChannel, FAQ, Product, FindBankAccount, ADDetail, Privacy, TermsAndConditions, ConsentDeclaration, AppPrivacy, AppTermsAndConditions, AppConsentDeclaration, Page404, OneClickPay, AppTermsOfUse, BankVirtualCollection, AppEsignTermsOfUse, FindAgreementNumber, FindMerchant, AppMotorConsent, AppMotorPrivacy, AppMotorTerms, AppPaymentSuccess } from './pages'

const AppRouter = () => {
  return (
    <Router basepath={ROOT_PATH}>
      <Home path="/">
        <Page404 path="*"></Page404>
        <SMHome path="/" />
        <ContactUs path="/contact-us" />
        <AboutUs path="/about-us" />
        <OurDealer path="our-dealer" />
        <News path="news" />
        <MotorcycleFinancing path="motorcycle-financing" />
        <ProductDisclosure path="product-disclosure" />
        <PersonalLoan path="personal-loan" />
        <MotorVehicle path="motor-vehicle" />
        <MobileApp path="mobile-app" />
        <RepaymentChannel path="repayment-channel" />
        <RepaymentChannel path="how-to-pay" />
        <FAQ path="faq" />
        <Product path="product" />
        <FindBankAccount path="find-bank-account" />
        <FindAgreementNumber path="find-agreement-number" />
        <FindMerchant path="find-merchant" />
        <NewsDetail path="news-detail" />
        <ADDetail path="ad-detail" />
        <Privacy path="privacy"></Privacy>
        <TermsAndConditions path="terms-conditions"></TermsAndConditions>
        <ConsentDeclaration path="consent-declaration"></ConsentDeclaration>
        <OneClickPay path="one-click-pay"></OneClickPay>
        <BankVirtualCollection path="bank-virtual-collection-account"></BankVirtualCollection>
      </Home>

      {/* <Register path="register" />
      <Forgot path="forgot/:type" />
      <Reset path="reset/password" />

      <Dashboard path="dashboard">
        <Message path="message" />
        <AccountSummary path="account" />
        <AccountDetail path="account/:id" />
        <Profile path="profile" />
        <KillSwitch path="killSwitch" />
        <PaymentHistory path="payment/history" />
        <ResultPage path="payment/result" />
        <ResultPage path="payment/result/:type" />
        <Payment path="payment/:ano" />
      </Dashboard> */}

      <AppPrivacy path="app/privacy"></AppPrivacy>
      <AppTermsAndConditions path="app/terms"></AppTermsAndConditions>
      <AppConsentDeclaration path="app/consent"></AppConsentDeclaration>
      <AppTermsOfUse path="app/termsOfUse"></AppTermsOfUse>
      <AppEsignTermsOfUse path="app/eSignTermsOfUse"></AppEsignTermsOfUse>
      <AppNewsDetail path="app/newsDetail"></AppNewsDetail>

      <AppMotorTerms path="app/motor/terms"></AppMotorTerms>
      <AppMotorConsent path="app/motor/consent"></AppMotorConsent>
      <AppMotorPrivacy path="app/motor/privacy"></AppMotorPrivacy>
      <AppPaymentSuccess path="mobile/payment/success" />

    </Router>
  )
}

export default AppRouter
